/**
 * Debug logger for preview cache system.
 * Only logs when ?previewDebug=true is in the URL.
 */

const DEBUG_QUERY_PARAM = 'previewDebug';

// Check once at module load time for performance
const isDebugEnabled = (): boolean => {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return params.get(DEBUG_QUERY_PARAM) === 'true';
};

const debugEnabled = isDebugEnabled();

export const debugLog = (prefix: string, message: string): void => {
  if (debugEnabled) {
    console.debug(`${prefix} ${message}`);
  }
};
